// eslint-disable-next-line no-unused-vars
export const userAbilities = (can: any) => {
  can('MANAGE', 'USER')
  can('ADD', 'USER')
  can('EDIT', 'USER')
}
